import styled, { css } from 'styled-components';
import { screen } from '../../../../common/breakpoints';

export const focusStyle = css`
  outline-offset: unset;
`;

export const ThreeSixtyViewerFocusElement = styled.div`
  position: absolute;
  touch-action: none;
  pointer-events: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export const ThreeSixtyViewControlsWrapper = styled.div<{
  disablePointerEvents?: boolean;
}>`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  ${({ disablePointerEvents }) => disablePointerEvents && `pointer-events: none;`}
`;

export const ThreeSixtyExteriorViewStyledImage = styled.img<{
  isVisible?: boolean;
}>`
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const ThreeSixtyExteriorViewSpinnerWrapper = styled.div`
  position: relative;
  pointer-events: none;
  scale: 0.5;

  @media screen and ${screen.l} {
    scale: 1;
  }
`;

export const ThreeSixtyExteriorViewFocusHelper = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;

  :focus-visible {
    ~ ${ThreeSixtyViewerFocusElement} {
      ${focusStyle}
    }
  }
`;

export const ThreeSixtyExteriorViewEllipse = styled.div<{ svgImage: string }>`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-image: url('${({ svgImage }) => svgImage}')};
  background-repeat: no-repeat;
  pointer-events: none;
  mix-blend-mode: hard-light;
  background-size: 94%;
  background-position-y: 80%;
  background-position-x: center;
`;

export const ThreeSixtyExteriorViewContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  cursor: grab;

  &:active {
    ${ThreeSixtyExteriorViewEllipse} {
      opacity: 0;
    }
  }
`;
